export default "__VITE_ASSET__L8nBpPxJiAolfp13rurrxg__";